import type { NetBankingOption } from '../../domain/payment/methods';

export const filterOptions = (
	inputValue: string,
	options: NetBankingOption[],
): NetBankingOption[] => {
	if (inputValue) {
		const startsWithMatches = options.filter((option) =>
			option.name.toLowerCase().startsWith(inputValue.toLowerCase()),
		);

		// If we found matches that start with the input, return those
		if (startsWithMatches.length > 0) {
			return startsWithMatches;
		}

		// Otherwise, search for options that include the input anywhere
		return options.filter((option) => option.name.toLowerCase().includes(inputValue.toLowerCase()));
	}
	return options;
};
